export default __webpack_public_path__ + "static/media/hardWork.dea0398e.svg";